import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import createBranchImg from '../../../src/images/figma/create-branch.png';
import createBranchDialogImg from '../../../src/images/figma/create-branch-dialog.png';
import requestReviewImg from '../../../src/images/figma/request-review.png';
import mergeDialogImg from '../../../src/images/figma/merge-dialog.png';
import requestDialogImg from '../../../src/images/figma/request-dialog.png';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ImageBox = makeShortcode("ImageBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`How can you contribute`}</h2>
    <p>{`Currently only `}<strong parentName="p">{`GitHub employees`}</strong>{` can contribute to `}<strong parentName="p">{`Primer Web`}</strong>{`, due to how Figma handles open source files.
To make changes you first need to `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=tbNCGEC2G1E"
      }}>{`create a branch`}</a>{` from Primer Web and name it `}<inlineCode parentName="p">{`@username/changes-being-made`}</inlineCode>{`.
For example: `}<inlineCode parentName="p">{`@lukasoppermann/update-button-radius`}</inlineCode>{`.`}</p>
    <p>{`When you are satisfied with the changes you made, request a review from the `}<a parentName="p" {...{
        "href": "https://github.com/primer/figma/blob/main/CONTRIBUTION.md#contribute-new-components-or-updates"
      }}>{`direct responsible individual`}</a>{` (DRI) of the file. If you are not sure who that is, reach out in the #primer-figma slack channel.`}</p>
    <p>{`Once your branch is approved, a maintainer will take care of merging and publishing the changes to the library.`}</p>
    <p>{`We use this process to make sure no accidental changes get added to the library. It also allows us to better track changes added by a branch. Think of it as a repo that does not allow direct pushes to the main branch.`}</p>
    <ImageBox caption="Select “Create branch...” from the dropdown or via the command palette" mdxType="ImageBox">
  <img width="410" alt="Screenshot showing how to create a branch in figma" src={createBranchImg} />
    </ImageBox>
    <ImageBox caption="Name your branch “@username/changes-being-made”" paddingX mdxType="ImageBox">
  <img width="293" alt="Screenshot showing the create branch dialog in figma" src={createBranchDialogImg} />
    </ImageBox>
    <ImageBox caption="When you are done request a review to get your changes merged." mdxType="ImageBox">
  <img width="730" alt="Screenshot showing the request review option in figma" src={requestReviewImg} />
    </ImageBox>
    <ImageBox caption="Select the DRI for the file to review. Reach out in the internal #primer-figma channel if you are not sure who to add." paddingX mdxType="ImageBox">
  <img width="568" alt="Screenshot showing the merge dialog in figma" src={mergeDialogImg} />
    </ImageBox>
    <ImageBox caption="Add a detailed message describe what you changed and why." paddingX mdxType="ImageBox">
  <img width="506" alt="Screenshot showing the request review text dialog in figma" src={requestDialogImg} />
    </ImageBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      